$('#form-modifica-profilo').submit(function (event) {
    event.preventDefault();
    var form = $(this);
    var text = '';

    overlay.fadeIn(function () {
        $('#form-modifica-profilo .errors').html('').parent().removeClass('has-error');
        $.ajax({
            url: form.attr('action'),
            type: 'POST',
            dataType: 'JSON',
            data: form.serialize(),
        })
        .done(function(data) {
            text = data;
        })
        .fail(function(error) {
            if (error.status == 422) {
                var errori = error.responseJSON;
                $.each(errori, function(index, val) {
                    var eError = $('#error-' + index);
                    eError.html(val[0]);
                    eError.parent().addClass('has-error');
                });
            }
        })
        .always(function() {
            overlay.fadeOut(function() {
                console.log(text);
                if (text) {
                    showResponse(text);
                }
            });
        });
        
    });
});

$('#form-modifica-dati-agenzia').submit(function (event) {
    event.preventDefault();
    var form = $(this);
    var text = '';

    overlay.fadeIn(function () {
        $('#form-modifica-dati-agenzia .errors').html('').parent().removeClass('has-error');
        $.ajax({
            url: form.attr('action'),
            type: 'POST',
            dataType: 'JSON',
            data: form.serialize(),
        })
        .done(function(data) {
            text = data;
        })
        .fail(function(error) {
            if (error.status == 422) {
                var errori = error.responseJSON;
                $.each(errori, function(index, val) {
                    var eError = $('#error-' + index);
                    eError.html(val[0]);
                    eError.parent().addClass('has-error');
                });
            }
        })
        .always(function() {
            overlay.fadeOut(function() {
                console.log(text);
                if (text) {
                    showResponse(text);
                }
            });
        });
        
    });
});

/* Gestione active navbar */
/*   $(".nav").find(".active").removeClass("active");
   $(this).addClass("active");
});*/

$(function () {
    setNavigation();
});

function setNavigation() {
    var path = window.location.href;
    path = path.replace(/\/$/, "");
    path = decodeURIComponent(path);

    $(".nav a[href='"+path+"']").closest('li').addClass('active');
    path = window.location.pathname;
    path = path.replace(/\/$/, "");
    path = decodeURIComponent(path);
    $(".nav a").each(function(){
        if ($(this).attr('href') === '/' && (path == '/agenzia' || path == '/admin') ) {$(this).closest('li').addClass('active');}    
    });
}




// WEBPACK FOOTER //
// ./resources/assets/js/script.js